export function showLoadingState() {
    this.hideAllStates();
    this.loadingState?.classList.remove('hidden');
}

export function showEmptyState() {
    this.hideAllStates();
    this.emptyState?.classList.remove('hidden');
}

export function showErrorState(message) {
    this.hideAllStates();
    this.errorState?.classList.remove('hidden');

    const errorMessage = document.getElementById('collections-error-message');
    if (errorMessage && message) {
        errorMessage.textContent = message;
    }
}

export function hideAllStates() {
    this.loadingState?.classList.add('hidden');
    this.emptyState?.classList.add('hidden');
    this.errorState?.classList.add('hidden');
}
